<template>
  <div
    :class="[
      images && images.length > 1 && !singular
        ? 'profile-thumbnail profile-thumbnail--multiple'
        : 'profile-thumbnail'
    ]"
  >
    <div v-if="images" class="profile-thumbnail__photo">
      <img :src="images[0]" alt="" />
    </div>
    <div v-if="images && images.length > 1 && !singular" class="profile-thumbnail__photo">
      <img :src="images[1]" alt="" />
    </div>
    <Badge v-if="unreaded">{{ unreaded }}</Badge>
  </div>
  <!-- / profile-thumbnail -->
</template>

<script>
import Badge from "@/components/Badge.vue";

export default {
  name: "ProfilePhoto",
  components: {
    Badge
  },
  props: {
    singular: Boolean,
    unreaded: Number,
    images: Array
  }
};
</script>

<style lang="scss">
.profile-thumbnail {
  position: relative;
  height: 50px;
  width: 50px;

  &__photo {
    border-radius: 99999px;
    position: absolute;
    overflow: hidden;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;

    img,
    svg {
      position: absolute;
      object-fit: cover;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }
  }

  &--multiple {
    .profile-thumbnail__photo {
      border: 3px solid $color-secondary;
      height: 36px;
      width: 36px;

      &:first-of-type {
        z-index: 1;
        bottom: 0;
        top: auto;
      }

      &:nth-of-type(2) {
        height: 34px;
        width: 34px;
        left: auto;
        right: 0;
      }
    }
  }

  .badge {
    position: absolute;
    right: -5px;
    z-index: 10;
    bottom: 0;
  }
}
</style>
